import {
  FinalizeProjectReviewPayload,
  ProjectReviewPeriodMode,
  ProjectReviewResult,
  ProjectSummaryReviewItemCommand,
} from './types';

const DEFAULT_PROJECT_REVIEW_PERIOD_MODE: ProjectReviewPeriodMode = 'CUSTOMER_PERIOD';

const getProjectReviewItems = (
  review: ProjectReviewResult,
  comments: Record<string, string>,
): ProjectSummaryReviewItemCommand[] => {
  const items = review.sections.flatMap(section =>
    section.groups.flatMap(group =>
      group.entities.map(entity => ({
        entityType: group.entityType,
        entityId: entity.entityId,
        section: section.section,
        entityName: entity.name,
        entityCode: entity.code,
        changes: entity.changes.map(change => ({
          changeType: change.changeType,
          property: change.property,
          oldValue: change.oldValue,
          newValue: change.newValue,
          occurredAt: change.occurredAt,
          changedBy: change.author,
          commitId: change.commitId,
        })),
        violations: entity.violations.map(violation => ({
          code: violation.code,
          message: violation.message,
        })),
        comment: comments[entity.entityId]?.trim() ?? '',
      })),
    ),
  );
  const entityKeys = new Set(items.map(item => `${item.entityType}-${item.entityId}`));
  const staleItemsWithoutEntity = review.violations
    .filter(violation => !entityKeys.has(`${violation.entityType}-${violation.entityId}`))
    .map(violation => ({
      entityType: violation.entityType,
      entityId: violation.entityId,
      section: '',
      entityName: null,
      entityCode: null,
      changes: [],
      violations: [
        {
          code: violation.code,
          message: violation.message,
        },
      ],
      comment: comments[violation.entityId]?.trim() ?? '',
    }));

  return [...items, ...staleItemsWithoutEntity].filter(item => item.comment);
};

export const getFinalizeProjectReviewPayload = (
  review: ProjectReviewResult,
  note: string,
  comments: Record<string, string>,
): FinalizeProjectReviewPayload => ({
  periodMode: review.periodMode ?? DEFAULT_PROJECT_REVIEW_PERIOD_MODE,
  from: review.from,
  to: review.to,
  noteText: note.trim() || undefined,
  items: getProjectReviewItems(review, comments),
});
